import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ae6421b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "msg_container sent_msg_container"
}
const _hoisted_2 = { class: "msg_text_container" }
const _hoisted_3 = {
  key: 1,
  class: "msg_container received_msg_container"
}
const _hoisted_4 = {
  key: 0,
  class: "image"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "msg_text_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.sent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.msg), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_ctx.image)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", { src: _ctx.image }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.msg), 1)
      ]))
}